/**
 * หน้าจอเปลี่ยนรหัสผ่านของเครื่องสแกน
 *
 * D-046 ให้ handheld ถือ session ยาว 16 ชั่วโมงเพื่อให้ operator เข้าสู่ระบบครั้งเดียว
 * ต่อกะ คนที่เพิ่งถูกบอกให้เปลี่ยนรหัสผ่านจึงกำลังยืนอยู่หน้าเครื่องสแกน ไม่ใช่หน้า
 * เครื่อง Desktop — การส่งเขาไปหาเครื่องอื่นเพื่อเปลี่ยนรหัสของตัวเองไม่ใช่ workflow
 *
 * หน้าจอนี้เป็นเพียงที่วางของ `ChangeOwnPasswordPanel` ตรรกะทั้งหมด (รวมทั้งการ
 * **ไม่** ล้าง session เมื่อเปลี่ยนสำเร็จตาม D-050) อยู่ใน panel นั้นที่เดียว
 * `deviceKind="HANDHELD"` คือสิ่งที่สั่งให้ฟอร์มใช้ขนาด touch target ของหน้างาน
 * (`touch.ts`) แทนขนาดของ Desktop
 */

import { useNavigate } from 'react-router-dom';

import { SCANNER_PATH } from './routes';
import './scanner.css';
import { ChangeOwnPasswordPanel } from '../lib/auth/ChangeOwnPasswordPanel';

export function ScannerPasswordScreen() {
  const navigate = useNavigate();

  return (
    <div className="cap-scanner" data-testid="scanner-password-screen">
      <header className="cap-scanner__top">
        <div className="cap-scanner__title">
          <span className="cap-scanner__app">CAP ERP · หน้างาน</span>
          <span className="cap-scanner__device">บัญชีของคุณ</span>
        </div>
      </header>

      <main className="cap-scanner__body">
        <ChangeOwnPasswordPanel
          deviceKind="HANDHELD"
          onClose={() => {
            // กลับหน้าจอสแกน ไม่ใช่หน้าเข้าสู่ระบบ — เซสชันของผู้เรียกยังอยู่
            navigate(SCANNER_PATH, { replace: true });
          }}
        />
      </main>
    </div>
  );
}
